var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-info"},[_c('h4',[_vm._v("Aún no hay información")])])
}]

export { render, staticRenderFns }